var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetsExternalapp24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2129 9.75H3.21289V8.25H22.2129V9.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7127 6C6.7127 5.44772 7.16042 5 7.7127 5H7.72168C8.27397 5 8.72168 5.44772 8.72168 6C8.72168 6.55228 8.27397 7 7.72168 7H7.7127C7.16042 7 6.7127 6.55228 6.7127 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7127 6C10.7127 5.44772 11.1604 5 11.7127 5H11.7217C12.274 5 12.7217 5.44772 12.7217 6C12.7217 6.55228 12.274 7 11.7217 7H11.7127C11.1604 7 10.7127 6.55228 10.7127 6Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60315 3.33008H17.8227C19.7557 3.33008 21.3227 4.89708 21.3227 6.83008V10.5283C21.3227 10.8045 21.5466 11.0283 21.8227 11.0283H22.3227C22.5988 11.0283 22.8227 10.8045 22.8227 10.5283V6.83008C22.8227 4.06865 20.5841 1.83008 17.8227 1.83008H7.60315C4.84173 1.83008 2.60315 4.06865 2.60315 6.83008V17.1699C2.60315 19.9313 4.84173 22.1699 7.60315 22.1699H17.8227C20.5841 22.1699 22.8227 19.9313 22.8227 17.1699V16.0381C22.8227 15.7619 22.5988 15.5381 22.3227 15.5381H21.8227C21.5466 15.5381 21.3227 15.7619 21.3227 16.0381V17.1699C21.3227 19.1029 19.7557 20.6699 17.8227 20.6699H7.60315C5.67015 20.6699 4.10315 19.1029 4.10315 17.1699V6.83008C4.10315 4.89708 5.67015 3.33008 7.60315 3.33008Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7047 13.2351C12.7047 12.8209 13.0405 12.4851 13.4547 12.4851H20.0242V13.9851H13.4547C13.0405 13.9851 12.7047 13.6493 12.7047 13.2351Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8772 10.9748C18.1676 10.6795 18.6425 10.6756 18.9378 10.966L20.335 12.34C20.8301 12.8269 20.8334 13.6241 20.3424 14.1151L18.9421 15.5154C18.6492 15.8083 18.1743 15.8083 17.8814 15.5154C17.5885 15.2225 17.5885 14.7477 17.8814 14.4548L19.1035 13.2327L17.886 12.0355C17.5907 11.745 17.5867 11.2702 17.8772 10.9748Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsExternalapp24);
export default __webpack_public_path__ + "static/media/assets-externalapp-24.9eec581f461609fcb92f57461aad16f4.svg";
export { ForwardRef as ReactComponent };